module.exports = __webpack_public_path__ + "static/media/Brndwrx-02.47849564.svg";